<div class="container-fluid">
  <div class="row" style="margin-bottom: 0">
    <div class="col-12">
      <div
        class="page-title-box d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2"
      >
        <h4 class="mb-0">Energy Dashboard</h4>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <div
            (click)="refreshClick()"
            title="Refresh"
            class="d-flex align-items-center px-2 py-1 text-white"
            style="
              background-color: #007d79;
              cursor: pointer;
              border-radius: 5px;
              transition: background-color 0.3s ease;
              box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            "
          >
            <i class="ri-refresh-line me-1"></i> Refresh
          </div>
          <div
            class="example-button-row ml-2"
            *ngIf="this.role == 'SUPERADMIN'"
          >
            <select
              class="form-control"
              [(ngModel)]="selectedCustomerId"
              (ngModelChange)="onChange($event)"
            >
              <option *ngFor="let custId of customerList" [ngValue]="custId">
                {{ custId.custName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-2">
      <label>Department</label>
      <select
        class="form-control custom-select"
        name="departmentName"
        id="departmentName"
        ngModel
        disableOptionCentering
        (ngModelChange)="select_Department($event)"
        [(ngModel)]="selectedDepartment"
      >
        <option
          *ngFor="let department of departmentData"
          [ngValue]="department.departmentName"
        >
          {{ department.departmentName }}
        </option>
      </select>
    </div>
    <div class="col-md-2" *ngIf="filterMachine.length">
      <div class="form-group">
        <label>Machine</label>
        <select
          class="form-control custom-select"
          (ngModelChange)="select_Machine($event)"
          name="machineName"
          id="machineName"
          ngModel
          disableOptionCentering
          [(ngModel)]="selectedMachine"
        >
          <option
            *ngFor="let machines of filterMachine"
            [ngValue]="machines.deviceName"
          >
            {{ machines.deviceName }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group col-md-2" *ngIf="filterMachine.length">
      <label>Shift</label>
      <select
        class="form-control custom-select"
        name="shiftName"
        id="shiftName"
        ngModel
        disableOptionCentering
        (ngModelChange)="select_Shift($event)"
        [(ngModel)]="selectedShift"
      >
        <option
          *ngFor="let shift of selectedDepartmentShift"
          [ngValue]="shift.shiftName"
        >
          {{ shift.shiftName }}
        </option>
      </select>
    </div>
    <div class="form-group col-md-2" *ngIf="filterMachine.length">
      <label>Date</label>
      <input
        class="form-control"
        type="date"
        [(ngModel)]="fromDate"
        (ngModelChange)="select_Date($event)"
        placeholder="{{ 'From-date' }}"
        id="example-date-input"
        [min]="mindate"
        [max]="maxdate"
      />
    </div>
    <div class="col-md-1" *ngIf="filterMachine.length">
      <button
        style="width: 100%; margin-top: 1.8rem"
        type="button"
        class="btn btn-success btn-rounded"
        (click)="getenergyData()"
      >
        Submit
      </button>
    </div>
    <div class="col-md-1" *ngIf="!chartBool && energyDatas">
      <button
        type="button"
        style="width: 100%; margin-top: 1.8rem"
        class="btn btn-primary btn-rounded"
        (click)="openModal(templatepdf, 'downloadpdfcsv', 'Export')"
      >
        Export
      </button>
    </div>
  </div>
  <div class="row g-3" *ngIf="filterMachine.length">
    <div class="col-md-3 col-sm-6 mb-3">
      <div
        class="metric-card energy border-start border-warning border-3 shadow-sm"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <p class="text-muted large mb-0 fw-bold">
              Total Energy
              <span
                *ngIf="chartBool"
                class="badge bg-light text-dark border fw-semibold px-2 py-1 small shadow-sm"
                >LUT:
                {{
                  energyData &&
                  energyData.energyData &&
                  energyData.energyData.LTS
                    ? energyData.energyData.LTS
                    : "0"
                }}</span
              >
            </p>
            <h6 class="fw-bold mb-0">
              {{ energyData?.energyData?.total_energy || 0 }} kWh
            </h6>
            <p class="small text-secondary mb-0">
              Energy Cost: {{ energyData?.energyData?.currency
              }}{{ energyData?.energyData?.total_energyCost || 0 }}
            </p>
          </div>
          <i class="mdi mdi-flash mdi-36px text-warning"></i>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6 mb-3">
      <div
        class="metric-card real-power border-start border-success border-3 shadow-sm"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <p class="text-muted large mb-2 fw-bold">Real Power</p>
            <h6 class="fw-bold mb-0 mt-2">
              {{
                (energyData?.energyData?.total_realPower || 0) >= 1000
                  ? ((energyData.energyData.total_realPower || 0) / 1000
                      | number : "1.2-2") + " kW"
                  : (energyData?.energyData?.total_realPower || 0) + " W"
              }}
            </h6>
          </div>
          <i class="mdi mdi-mine mdi-36px text-success"></i>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6 mb-3">
      <div
        class="metric-card apparent-power border-start border-primary border-3 shadow-sm"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <p class="text-muted large mb-2 fw-bold">Apparent Power</p>
            <h6 class="fw-bold mb-0 mt-2">
              {{
                (energyData?.energyData?.total_apparentPower || 0) >= 1000
                  ? ((energyData.energyData.total_apparentPower || 0) / 1000
                      | number : "1.2-2") + " kVA"
                  : (energyData?.energyData?.total_apparentPower || 0) + " VA"
              }}
            </h6>
          </div>
          <i class="mdi mdi-power-socket mdi-36px text-primary"></i>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6 mb-3">
      <div
        class="metric-card reactive-power border-start border-info border-3 shadow-sm"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <p class="text-muted large mb-2 fw-bold">Reactive Power</p>
            <h6 class="fw-bold mb-0 mt-2">
              {{
                (energyData?.energyData?.total_reactivePower || 0) >= 1000
                  ? ((energyData.energyData.total_reactivePower || 0) / 1000
                      | number : "1.2-2") + " kVAR"
                  : (energyData?.energyData?.total_reactivePower || 0) + " VAR"
              }}
            </h6>
          </div>
          <i class="mdi mdi-lightbulb-multiple-outline mdi-36px text-info"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="filterMachine.length">
    <div class="col-md-12">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            *ngIf="!showenergyload"
            echarts
            [options]="energyChartOption"
            (chartInit)="onChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"
          ></div>
          <div
            *ngIf="showenergyload"
            class="d-flex flex-column align-items-center justify-content-center text-center"
          >
            <ngx-spinner
              bdColor="rgba(0, 0, 0, 0)"
              size="medium"
              color="rgba(0, 0, 0, 0.1)"
              type="ball-scale-multiple"
              [fullScreen]="false"
            ></ngx-spinner>
            <span style="margin-top: 80px">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="livebool && filterMachine.length">
    <div class="col-md-12">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            *ngIf="!showenergyload"
            echarts
            [options]="voltageChartOption"
            (chartInit)="onvoltChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"
          ></div>
          <div
            *ngIf="showenergyload"
            class="d-flex flex-column align-items-center justify-content-center text-center"
          >
            <ngx-spinner
              bdColor="rgba(0, 0, 0, 0)"
              size="medium"
              color="rgba(0, 0, 0, 0.1)"
              type="ball-scale-multiple"
              [fullScreen]="false"
            ></ngx-spinner>
            <span style="margin-top: 80px">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="livebool && filterMachine.length">
    <div class="col-md-12">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            *ngIf="!showenergyload"
            echarts
            [options]="currentChartOption"
            (chartInit)="oncurChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"
          ></div>
          <div
            *ngIf="showenergyload"
            class="d-flex flex-column align-items-center justify-content-center text-center"
          >
            <ngx-spinner
              bdColor="rgba(0, 0, 0, 0)"
              size="medium"
              color="rgba(0, 0, 0, 0.1)"
              type="ball-scale-multiple"
              [fullScreen]="false"
            ></ngx-spinner>
            <span style="margin-top: 80px">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="livebool && filterMachine.length">
    <div class="col-md-12">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            *ngIf="!showenergyload"
            echarts
            [options]="powerfactorChartOption"
            (chartInit)="onpfChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"
          ></div>
          <div
            *ngIf="showenergyload"
            class="d-flex flex-column align-items-center justify-content-center text-center"
          >
            <ngx-spinner
              bdColor="rgba(0, 0, 0, 0)"
              size="medium"
              color="rgba(0, 0, 0, 0.1)"
              type="ball-scale-multiple"
              [fullScreen]="false"
            ></ngx-spinner>
            <span style="margin-top: 80px">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!chartBool && filterMachine.length">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title mb-3">Energy Parameters</h5>
          <div *ngIf="!tableDataKeys.length" class="text-center text-muted">
            No Data.
          </div>
          <div
            class="table-responsive table-container"
            *ngIf="tableDataKeys.length"
          >
            <table
              class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0"
            >
              <thead class="table-dark">
                <tr>
                  <th>Parameter</th>
                  <th>Minimum Value</th>
                  <th>Maximum Value</th>
                  <th>Average Value</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let key of tableDataKeys
                      | slice : pageSize
                      | slice : 0 : itemsPerPage
                  "
                >
                  <td>{{ formatKey(key) }}</td>
                  <td>
                    Value:
                    {{
                      energyData &&
                      energyData.tableData &&
                      energyData.tableData[key]
                        ? energyData.tableData[key][0]?.min
                        : "0"
                    }}{{
                      key === "currentB" ||
                      key === "currentR" ||
                      key === "currentY"
                        ? " A"
                        : key === "voltageB" ||
                          key === "voltageR" ||
                          key === "voltageY"
                        ? " V"
                        : key === "powerFactorB" ||
                          key === "powerFactorR" ||
                          key === "powerFactorY"
                        ? ""
                        : ""
                    }}<br />
                    Time:
                    {{
                      energyData &&
                      energyData.tableData &&
                      energyData.tableData[key]
                        ? energyData.tableData[key][0]?.ts
                        : "0"
                    }}
                  </td>
                  <td>
                    Value:
                    {{
                      energyData &&
                      energyData.tableData &&
                      energyData.tableData[key]
                        ? energyData.tableData[key][1]?.max
                        : "0"
                    }}{{
                      key === "currentB" ||
                      key === "currentR" ||
                      key === "currentY"
                        ? " A"
                        : key === "voltageB" ||
                          key === "voltageR" ||
                          key === "voltageY"
                        ? " V"
                        : key === "powerFactorB" ||
                          key === "powerFactorR" ||
                          key === "powerFactorY"
                        ? ""
                        : ""
                    }}<br />
                    Time:
                    {{
                      energyData &&
                      energyData.tableData &&
                      energyData.tableData[key]
                        ? energyData.tableData[key][1]?.ts
                        : "0"
                    }}
                  </td>
                  <td>
                    {{
                      energyData &&
                      energyData.tableData &&
                      energyData.tableData[key]
                        ? energyData.tableData[key][2]?.avg
                        : "0"
                    }}{{
                      key === "currentB" ||
                      key === "currentR" ||
                      key === "currentY"
                        ? " A"
                        : key === "voltageB" ||
                          key === "voltageR" ||
                          key === "voltageY"
                        ? " V"
                        : key === "powerFactorB" ||
                          key === "powerFactorR" ||
                          key === "powerFactorY"
                        ? ""
                        : ""
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="tableDataKeys?.length"
                [pageSize]="itemsPerPage"
                [(page)]="currentPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)"
              >
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="filterMachine.length  == 0">
    <div class="col-md-12">
       <div class="card">
        <div class="card-body">
          No Energy Meter is Configured
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #templatepdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click'); cancel()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <ul
        ngbNav
        #justifiednav="ngbNav"
        [activeId]="1"
        class="nav-pills nav-justified"
      >
        <li (click)="directExpo()" [ngbNavItem]="1">
          <a ngbNavLink>
            <h6 class="">Direct Export</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="directExport"></ng-template>
          </ng-template>
        </li>
        <li (click)="mailexport()" [ngbNavItem]="2">
          <a ngbNavLink>
            <h6 class="">Export via Email</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="mailExport"></ng-template>
          </ng-template>
        </li>
      </ul>
      &nbsp;&nbsp;
      <div [ngbNavOutlet]="justifiednav"></div>
      <div class="text-right mt-3">
        <button
          *ngIf="!exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
        >
          Export
        </button>
        <button
          *ngIf="exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
          [disabled]="!mailform.get('email').value"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #directExport>
  <form>
    <div>
      <p>Select the file type you would like to export</p>
    </div>
    <span
      class="pdf"
      [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
      ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
    >&nbsp;&nbsp;
    <span
      class="csv"
      [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
      ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
    >
    &nbsp;&nbsp;
  </form>
</ng-template>
<ng-template #mailExport>
  <div>
    <p>Select the file type you would like to export</p>
  </div>
  <span
    class="pdf"
    [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
    ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
  >&nbsp;&nbsp;
  <span
    class="csv"
    [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
    ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
  >&nbsp;&nbsp;
  <div>
    <form [formGroup]="mailform">
      <div class="form-group col-md-8">
        &nbsp;&nbsp;

        <input
          class="form-control"
          id="email"
          placeholder="user@gmail.com"
          formControlName="email"
          required
          [ngClass]="{ 'is-invalid': isEmailInvalid() }"
        />
        <div *ngIf="isEmailInvalid()">
          <span *ngIf="email.hasError('required')" style="color: red"
            >Email is required</span
          >
          <span *ngIf="email.hasError('email')" style="color: red"
            >Invalid email address</span
          >
        </div>
      </div>
    </form>
  </div>
</ng-template>
